import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import {
    makeSelectTimesheetValue
    // @ts-ignore
} from 'services/timesheets/selectors';

// Components
// @ts-ignore
import IsApprovedStatusIcon from '../../../../../../../../components/IsApprovedStatusIcon';

interface IOwnProps {
    timesheetId: number;
}

interface IStateProps {
    isApproved?: string;
}

interface IDispatchProps {}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class TimesheetIsApproved extends React.PureComponent<IProps> {
    render() {
        const { isApproved } = this.props;
        return <IsApprovedStatusIcon isApproved={isApproved} />;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isApproved: makeSelectTimesheetValue('isApproved')
});

export default connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps)(
    TimesheetIsApproved
);
